import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const ThankPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      className="mobile-app-container"
      sx={{
        height: '100vh',
        width: '100%',
        backgroundImage: 'url(/assets/backgroundOne.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundColor:'rgba(65, 160, 201, 0.7)',

        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 3,
      }}
    >
      <Box
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          borderRadius: '20px',
          padding: 4,
          maxWidth: '600px',
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        }}
      >
        <CheckCircleIcon sx={{ fontSize: 80, color: '#4CAF50', mb: 2 }} />
        
        <Typography 
          variant="h4" 
          sx={{ 
            fontWeight: 'bold', 
            color: '#784e3c', 
            mb: 2,
            fontFamily: 'Achiko'
          }}
        >
          Merci !
        </Typography>
        
        <Typography variant="h6" sx={{ mb: 3, color: '#333' }}>
          Le profil de votre enfant a été analysé avec succès
        </Typography>
        
        <Box sx={{ mb: 4 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Un email avec tous les détails vous a été envoyé.
          </Typography>
          <Typography variant="body1">
            N'hésitez pas à consulter votre boîte de réception à partir de maintenant.
          </Typography>
        </Box>
        
        <Button
          variant="contained"
          fullWidth
          onClick={() => navigate('/HomePage')}
          sx={{
            backgroundColor: '#784e3c',
            color: 'white',
            fontWeight: 'bold',
            fontSize: '1.1rem',
            textTransform: 'none',
            borderRadius: '50px',
            py: 1.5,
            mb: 2,
            boxShadow: '0px 4px 10px rgba(181, 129, 54, 0.4)',
            '&:hover': {
              backgroundColor: '#B58136',
              boxShadow: '0px 6px 15px rgba(181, 129, 54, 0.6)',
            }
          }}
        >
          Retour à l'accueil
        </Button>
      </Box>
    </Box>
  );
};

export default ThankPage;